import React from "react";
import "../../css/designSystem/BlogCard.css";
import OutlinedButton from "./OutlinedButton";

const BlogCard = ({ image, title, description, datePosted, link }) => {
  return (
    <div className="blog-card">
      <div className="blog-card-image-wrapper">
        <img src={image} alt={title} className="blog-card-image" />
      </div>
      <div className="blog-card-content">
        <div className="subtitle-semibold  grey">{title}</div>
        <div className="content grey">{description}</div>
        <div className="help-text grey">{datePosted}</div>

        {link && (
          // <a href={link} className="blog-card-button">
          //   Read More
          // </a>
          <OutlinedButton
            text="Read More"
            onClick={() => (window.location.href = link)}
          />
        )}
      </div>
    </div>
  );
};

export default BlogCard;
